const map = {
	"./cs354_hard_100_questions.json": 854,
	"./cs381-hard.json": 928,
	"./cs381.json": 754,
	"./cs408-hard.json": 730,
	"./cs408.json": 252,
	"./stat350_exam1_study_set_75q.json": 316
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;